__webpack_require__.p = "https://varsharani9.github.io/Google-Calculator/";